import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/authcontext";
import { useTenantRole } from "../../components/TenantRoleDisplay";

const RequireAuth: React.FC = () => {
  const { auth, selectedTenantId } = useContext(AuthContext);
  const { pathname } = useLocation();
  const role = useTenantRole(selectedTenantId || "");

  const authRoutes = [
    "/login",
    "/register",
    "/forgot-password",
    "/reset-password",
    "/account-verification",
    "/email-verification",
    "/email-connection",
    "/success",
    "/coming-soon",
    "/error-404",
    "/error-500",
    "/under-maintenance"
  ];

  const dynamicAuthRoutes = [
    "/reset-password/",
    "/account-verification/"
  ];

  const isAuthRoute = authRoutes.includes(pathname) ||
    dynamicAuthRoutes.some(route => pathname.startsWith(route));

  if (auth && isAuthRoute) {
    return <Navigate to="/dashboard/crm-dashboard" replace />;
  }

  if (isAuthRoute) {
    return <Outlet />;
  }

  if (!auth) {
    return <Navigate to="/login" state={{ from: { pathname } }} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
